import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { usePagesContext } from '../context/PagesContext';

// Pages
import LoginAndRegistrationPageSettings from './LoginAndRegistrationPage';
import ProgramsConstructorPage from './ProgramsConstructorPage';
import QuizConstructorPage from './QuizConstructorPage';
import MembersConstructorPage from './MembersConstructorPage';
import BroadcastConstructorPage from './BroadcastConstructorPage';
import HallsConstructorPage from './HallsConstructorPage';
import DefaultConstructorPage from './DefaultConstructorPage';
import LobbyConstructorPage from './LobbyConstructorPage';
import ShopConstructorPage from './ShopConstructorPage';
import ProfileConstructorPage from './ProfileConstructorPage';

const templates = {
    registration: LoginAndRegistrationPageSettings,
    lobby: LobbyConstructorPage,
    program: ProgramsConstructorPage,
    quiz: QuizConstructorPage,
    members: MembersConstructorPage,
    broadcast: BroadcastConstructorPage,
    halls: HallsConstructorPage,
    shop: ShopConstructorPage,
    profile: ProfileConstructorPage,
};

const PagesEdit = ({event}) => {
    const [pageData, setPageData] = useState(null);
    const params = useParams();
    const { handlePageDetails } = usePagesContext();

    const PageComponent = useMemo(() => {
        if (!pageData) return null;

        return templates[pageData.template] || DefaultConstructorPage;
    }, [pageData]);

    useEffect(handleGetPage, [params.pageId]);

    function handleGetPage() {
        handlePageDetails(params.pageId)
            .then((response) => {
                setPageData(response || null);
            });
        }

    if (!PageComponent) {
        return null;
    }

    return (
        <PageComponent event={event} pageData={pageData} />
    )
}


const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	};
};

export default connect(mapStateToProps)(PagesEdit);
